import GenericForm from "Admin/components/GenericForm";

function CreateClientes() {
    return (
      <div className="h-full flex flex-col">

      <GenericForm
        title="Cadastro de Clientes"
        description="Preencha as informações do cliente"
        endpoint="/novocliente"
        fields={[
          { name: "Informações", label: "informações de usuário", type: "title", default: true },
          { name: "nome", label: "Nome", type: "text", required: true },
          { name: "cpf", label: "CPF", type: "text", required: false  },
          { name: "rg", label: "RG", type: "text" },
          { name: "cnpj", label: "CNPJ", type: "text" },
          { name: "data_nascimento", label: "Data de Nascimento", type: "date" },
          { name: "observacoes", label: "Observações", type: "textarea" },
          { name: "status", label: "Ativo", type: "checkbox", default: true },

          
          // Contatos
          { name: "Contatos", label: "informações de contato", type: "title", default: true },
          { name: "email", label: "E-mail", type: "email", required: false },
          { name: "contato_telefone_1", label: "Telefone", type: "text", required: true },
          { name: "contato_obs_1", label: "Observação", type: "textarea" },

          { name: "Contato (alt)", label: "informações de contato alternativo", type: "title", default: true },
          { name: "contato_telefone_2", label: "Telefone (alt)", type: "text" },
          { name: "contato_obs_2", label: "Observação (alt)", type: "textarea" },

          
          { name: "Endereço", label: "informações de endereço", type: "title", default: true },
          { name: "endereco1_cep", label: "CEP", type: "text" },
          { name: "endereco1_endereco", label: "Endereço", type: "text" },
          { name: "endereco1_numero", label: "Número", type: "text" },
          { name: "endereco1_complemento", label: "Complemento", type: "text" },
          { name: "endereco1_ponto_referencia", label: "Ponto de Referência", type: "text" },
          { name: "endereco1_bairro", label: "Bairro", type: "text" },
          { name: "endereco1_estado", label: "Estado", type: "text" },
          { name: "endereco1_cidade", label: "Cidade", type: "text" },
  
          // Endereço 2
          { name: "Endereço (alt)", label: "informações de endereço alternativo", type: "title", default: true },
          { name: "endereco2_cep", label: "CEP (alt)", type: "text" },
          { name: "endereco2_endereco", label: "Endereço (alt)", type: "text" },
          { name: "endereco2_numero", label: "Número (alt)", type: "text" },
          { name: "endereco2_complemento", label: "Complemento (alt)", type: "text" },
          { name: "endereco2_ponto_referencia", label: "Ponto de Referência (alt)", type: "text" },
          { name: "endereco2_bairro", label: "Bairro (alt)", type: "text" },
          { name: "endereco2_estado", label: "Estado (alt)", type: "text" },
          { name: "endereco2_cidade", label: "Cidade (alt)", type: "text" },
        ]}
      />
      </div>
    );
  }
  
  export default CreateClientes;
  
